/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AutopayAction from './AutopayAction/index'
import InsuranceClaimsAction from './InsuranceClaimsAction/index'
import React from 'react'
import StatementsAction from './StatementsAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/Content/Financial/Tabs"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Tabs.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-brpv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-brpv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-3-brpv': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Tabs.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-4-brpv': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<AutopayAction
  viewPath={`${viewPath}/AutopayAction`}
/>
<InsuranceClaimsAction
  viewPath={`${viewPath}/InsuranceClaimsAction`}
/>
<StatementsAction
  viewPath={`${viewPath}/StatementsAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}